import { Component, OnInit, OnDestroy } from "@angular/core";
import { Params, Router, ActivatedRoute } from "@angular/router";
import { SubscriptionPlansService } from "../services/subscription-plans.service";
import { BaseEditComponent } from "../../core/common/base-component";
import { FormUtil } from "../../core/form.util";
import { RouteHelperService } from "../../core/services/route-helper.service";
import { CouponsService } from "../../coupons/services/coupons.service";
import { Title } from '@angular/platform-browser';
@Component({
  selector: "ch-subscription-plans-edit",
  templateUrl: "./subscription-plans-edit.component.html",
  styleUrls: ["./subscription-plans-edit.component.css"]
})
export class SubscriptionPlansEditComponent extends BaseEditComponent
  implements OnInit, OnDestroy {
  public SubscriptionPlansData: any = {};
  public locationName: string;
  private type: string;
  private plansId: string;
  private parentId: string;
  private planName: string;

  public currency = "GBP";
  public types: any;
  public coupons: any;
  public intervalTypes: string[];

  public errors: any = {};

  public chosenSubscriptionPlans = false;

  public breadcrumb: any[] = [];

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private subscriptionPlansService: SubscriptionPlansService,
    private couponsService: CouponsService,
    private routeHelperService: RouteHelperService,
    private titleService: Title,
  ) {
    super();
  }

  ngOnInit() {
    this.subscriptionPlansService.getAllTypes().subscribe(res => {
      this.types = res.json();
    });
    this.couponsService.getAllCoupons().subscribe(res => {
      this.coupons = res.json();
    });
    this.subscriptionPlansService.getAllIntervalTypes().subscribe(res => {
      this.intervalTypes = res.json();
    });

    this.activatedRoute.queryParamMap
      .map((params: Params) => params.params)
      .subscribe(params => {
        this.editMode = this.routeHelperService.isCurrentPageEdit();
        this.plansId = params.id;
        this.parentId = params.parentId;

        if (this.editMode) {
          this.fetchData(this.plansId);
          this.setSubscriptionPlansBreadcrumb(this.plansId);
        } else {
          this.titleService.setTitle(`New Subscription Plan | CODE Hospitality CMS`);
          this.type =
            "string" === typeof params.type
              ? params.type.trim().toLowerCase()
              : "";
          this.setSubscriptionPlansBreadcrumb(this.parentId, "Add");
        }
      });
    this.SubscriptionPlansData.currency = this.currency;
  }

  ngOnDestroy() {
    this.titleService.setTitle(`CODE Hospitality CMS`);
  }

  private fetchData(id: string) {
    this.loading = true;
    this.subscriptionPlansService.getProductPlan(id).subscribe(
      data => {
        this.SubscriptionPlansData = data.json();
        this.planName = this.SubscriptionPlansData["name"];
        this.titleService.setTitle(`${this.planName} | Subscription Plans | CODE Hospitality CMS`);
      },
      () => {},
      () => {
        this.loading = false;
        this.loaded = true;
      }
    );
  }

  private setSubscriptionPlansBreadcrumb(id: string, last?: string) {
    if (!id) {
      this.breadcrumb = ["Subscription Plans", this.editMode ? "" : "Add New"];
      return;
    }

    this.subscriptionPlansService
      .getLocationParentTree(id)
      .then((resp: any[]) => {
        if (last) {
          resp.push(last);
        }

        const a = ["Subscription Plans", ...resp];
        const result = [];

        for (let i = 0; i < a.length; i++) {
          const item = a[i];
          if ("object" === typeof item) {
            result.push({
              name: item.name,
              data: item.id
            });
          } else {
            result.push(
              0 === i
                ? {
                    name: item,
                    data: "top"
                  }
                : item
            );
          }
        }

        this.breadcrumb = result;
      });
  }

  public breadcrumbGoTo(data) {
    if ("top" === data) {
      this.router.navigate(["/admin/subscription-plans"]);
    } else {
      this.goToSubroute(data);
    }
  }

  public goToSubroute(id: string) {
    this.router.navigate(["/admin/subscription-plans"], {
      queryParams: { parentId: id }
    });

    return false;
  }

  public markDefault(checked) {
    this.SubscriptionPlansData.isDefault = checked;
  }

  public markRafDefault(checked) {
    this.SubscriptionPlansData.isRafDefault = checked;
  }

  public edit(form) {
    if (!FormUtil.isValid(form)) {
      return;
    }

    const reqData: any = { ...this.SubscriptionPlansData };

    if (this.editMode) {
      delete reqData.amount;
      delete reqData.currency;
      delete reqData.intervalUnit;
      delete reqData.intervalValue;
      delete reqData.trialPeriodDays;
      delete reqData.createdAt;
      delete reqData.stripePlanId;
      delete reqData.updatedAt;
      delete reqData.type;
    }

    const methodName = this.editMode
      ? "editSubscriptionPlans"
      : "addSubscriptionPlans";

    this.loading = true;
    this.subscriptionPlansService[methodName](reqData).subscribe(
      _ => {
        this.loading = false;
        this.cancel();
      },
      err => {
        this.loading = false;
        if (!(err.errors instanceof Array)) {
          return;
        }
        err.errors.forEach(item => {
          this.errors[item.field] = item.message;
        });
      }
    );
  }

  public archive() {
    this.subscriptionPlansService.archivePlan(this.plansId).subscribe(_ => {
      this.cancel();
    });
  }

  public unarchive() {
    this.subscriptionPlansService.unarchivePlan(this.plansId).subscribe(_ => {
      this.cancel();
    });
  }

  public delete() {
    if (!confirm("Are you sure you want to delete this subscription plan?")) {
      return;
    }

    this.subscriptionPlansService.deletePlan(this.plansId).subscribe(resp => {
      this.cancel();
    });
  }

  public cancel() {
    const targetSubscriptionPlansId = this.plansId;
    const url =
      "/admin/subscription-plans" +
      (targetSubscriptionPlansId
        ? "?parentId=" + targetSubscriptionPlansId
        : "");
    this.router.navigateByUrl(url);
  }

  public onSubscriptionPlansChange(event: any) {
    this.SubscriptionPlansData.latitude = event.coords.lat;
    this.SubscriptionPlansData.longitude = event.coords.lng;

    this.chosenSubscriptionPlans = true;
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/subscription-plans/subscription-plans-edit/subscription-plans-edit.component.ts